import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import BankModal from "../../core/modals/bank/BankModal";
import { fetchBanks, deleteBankThunk } from "../../core/redux/slices/bankSlice";

const fmt = (v) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });

const BankList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.bank);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchBanks()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((b) => !q || b.bankName?.toLowerCase().includes(q));
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchBanks()); };

  const columns = [
    { title: "Bank Name", dataIndex: "bankName", sorter: (a, b) => a.bankName.localeCompare(b.bankName) },
    { title: "Opening Balance", dataIndex: "openingBalance", align: "right", width: 160, render: (v) => `₹${fmt(v)}` },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteBankThunk(rec.id)), rec.bankName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Bank" subtitle="Manage bank accounts" onAdd={openAdd} addLabel="Add Bank" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search bank..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <BankModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default BankList;
